// Lightweight referral helpers. A ?ref=CODE in the URL is stored so we can
// credit the referrer when this visitor eventually subscribes.
const REF_KEY = "sb-ref";

export const captureRefFromUrl = () => {
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem(REF_KEY, ref.slice(0, 16));
  } catch (e) { /* ignore */ }
};

export const getStoredRef = () => {
  try { return localStorage.getItem(REF_KEY) || ""; } catch (e) { return ""; }
};
